import { render } from "./SecurityChangePassword.vue?vue&type=template&id=3d99aeec&ts=true"
import script from "./SecurityChangePassword.vue?vue&type=script&lang=ts"
export * from "./SecurityChangePassword.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__